import React, {useState} from "react";
import Modal from '@material-ui/core/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import {
    FacebookShareButton,
    FacebookMessengerShareButton,
    WhatsappShareButton,
    FacebookIcon,
    FacebookMessengerIcon,
    WhatsappIcon
} from "react-share";
import copy from 'copy-to-clipboard';
import Moment from 'moment';

import Facebook from '../assets/img/facebook.png';
import FacebookMessenger from '../assets/img/facebook_messenger.png';
import Whatsapp from '../assets/img/whatsapp.png';
import Gmail from '../assets/img/gmail.png';
import CLink from '../assets/img/clink.png';

const InviteModal = ({
    open = false, 
    inviteMessageTitle = '',
    inviteMessageBody = '',
    inviteMessageFooter = '',
    meetingTitle = '', 
    meetingId = '',
    meetingPassword = '',
    meetingTime = '',
    onClose = () => {}, 
    ...props}) => {
    const [fbRef, setFbRef] = useState(null);
    const [fbmRef, setFbmRef] = useState(null);
    const [whatsappRef, setWhatsappRef] = useState(null);
    const [isCopyClipShow, setIsCopyClipShow] = useState(false);

    const shareContent = inviteMessageTitle + '\n' + inviteMessageBody + inviteMessageFooter;

    const handleFacebook = () => {
        fbRef.click();
    }

    const handleFbMessenger = () => {
        fbmRef.click();
    }

    const handleWhatsapp = () => {
        whatsappRef.click();
    }

    const handleGmail = () => {
        window.open(`https://mail.google.com/mail/?view=cm&source=mailto&body=${shareContent}`, '_blank');
    }

    const handleLink = () => {
        copy(shareContent);
        setIsCopyClipShow(true);

        setTimeout(() => {
            setIsCopyClipShow(false);
        }, 1500);
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            {...props}
        >
            <div className="c_modal iv_modal">
                <div className="sub_cmodal">
                    <div className="modal_header">
                        <div className="title">
                            Invite to the meeting
                        </div>
                        <div className="btn_close" onClick={() => onClose()}>
                            <FontAwesomeIcon className="fa_icon" icon={faTimes} />
                        </div>
                    </div>
                    <div className="modal_content">
                        <div className="meeting_details">
                            <p>Meeting Title: {meetingTitle}</p>
                            <p>Meeting ID: {meetingId}</p>
                            <p>Password: {meetingPassword}</p>
                            <p>Date: {Moment.unix(meetingTime).format('D MMM YYYY')}</p>
                            <p>Time: {Moment.unix(meetingTime).format('h:mm a')}</p>
                        </div>
                        <div className="meeting_share">
                            <div className="ct_iv_btn" onClick={() => handleFacebook()}>
                                <img src={Facebook} alt="Facebook" />
                            </div>
                            <div className="ct_iv_btn" onClick={() => handleFbMessenger()}>
                                <img src={FacebookMessenger} alt="Facebook Messenger" />
                            </div>
                            <div className="ct_iv_btn" onClick={() => handleWhatsapp()}>
                                <img src={Whatsapp} alt="Whatsapp" />
                            </div>
                            <div className="ct_iv_btn" onClick={() => handleGmail()}>
                                <img src={Gmail} alt="Gmail" />
                            </div>
                            <div className="ct_iv_btn" onClick={() => handleLink()}>
                                <img src={CLink} alt="Link" />
                            </div>
                        </div>
                        {
                            isCopyClipShow && 
                            <p className="copy_clip">Copied to clipboard</p>
                        }
                    </div>
                    <div>
                        <FacebookShareButton
                            ref={ref => setFbRef(ref)}
                            url="app.meetnow.in"
                            quote={shareContent}
                            hashtag="#meetnow facebook share"
                            hidden={true}>
                            <FacebookIcon iconFillColor="white" />
                        </FacebookShareButton>
                        <FacebookMessengerShareButton
                            ref={ref => setFbmRef(ref)}
                            url="app.meetnow.in"
                            appId="2751773398424971"
                            hidden={true}>
                            <FacebookMessengerIcon iconFillColor="white" />
                        </FacebookMessengerShareButton>
                        <WhatsappShareButton
                            ref={ref => setWhatsappRef(ref)}
                            url="app.meetnow.in"
                            hidden={true}>
                            <WhatsappIcon iconFillColor="white" />
                        </WhatsappShareButton>
                    </div>
                </div>
            </div>
        </Modal>
    ) 
}

export default InviteModal;